import { Role } from '@form-factory/schema/enums';
import { Badge } from '@utima/ui';
import { memo } from 'react';

import { useEnumTranslations } from '@/hooks';

export type RoleBadgeProps = {
  role: Role;
};

function getRoleVariant(role: Role) {
  switch (role) {
    case Role.SuperAdmin:
      return 'danger';
    case Role.Admin:
      return 'info';

    default:
      return 'info';
  }
}

export const RoleBadge = memo(function RoleBadge({ role }: RoleBadgeProps) {
  const enumTranslations = useEnumTranslations();

  return (
    <Badge
      className='inline-flex'
      variant={getRoleVariant(role)}
      size='sm'
      outline
    >
      {enumTranslations.role[role]}
    </Badge>
  );
});
